import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ability-open"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5.00007 19.0001C5.00007 18.6006 4.84393 18.2377 4.58936 17.9688L11.4813 5.90796C11.643 5.96755 11.8177 6.00009 12.0001 6.00009C12.1824 6.00009 12.3572 5.96755 12.5189 5.90796L19.4108 17.9688C19.1562 18.2377 19.0001 18.6006 19.0001 19.0001H5.00007Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 19C5 19.8284 4.32843 20.5 3.5 20.5C2.67157 20.5 2 19.8284 2 19C2 18.1716 2.67157 17.5 3.5 17.5C3.92898 17.5 4.31589 17.6801 4.58928 17.9688M5 19C5 18.6005 4.84386 18.2376 4.58928 17.9688M5 19H19M19 19C19 19.8284 19.6716 20.5 20.5 20.5C21.3284 20.5 22 19.8284 22 19C22 18.1716 21.3284 17.5 20.5 17.5C20.071 17.5 19.6841 17.6801 19.4107 17.9688M19 19C19 18.6005 19.1561 18.2376 19.4107 17.9688M4.58928 17.9688L11.4812 5.90787M11.4812 5.90787C11.6429 5.96746 11.8176 6 12 6C12.1824 6 12.3571 5.96746 12.5188 5.90787M11.4812 5.90787C10.9085 5.69674 10.5 5.14607 10.5 4.5C10.5 3.67157 11.1716 3 12 3C12.8284 3 13.5 3.67157 13.5 4.5C13.5 5.14607 13.0915 5.69674 12.5188 5.90787M12.5188 5.90787L19.4107 17.9688","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AbilityOpen = Vue.extend<IconProps>({
  name: 'AbilityOpenIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ability-open',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AbilityOpen;
